export default __webpack_public_path__ + "assets/images/arrow-down.21e4eaff403ffe00325a53dcf16ae0bf.png";